import { Dialog, DialogContentText } from "@mui/material";
import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";

export const WorkspaceMenuWrapper = styled.div`
  height: 96px;
  position: absolute;
  right: 0;
  z-index: 9999;
`;

export const MenuWrapper = styled.div`
  background-color: ${palette.colors.surface_container};
  padding: 8px 0;
  border-radius: ${shape.rounding.M};
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15),
    0px 1px 2px 0px rgba(0, 0, 0, 0.3);
  margin-top: 4px;
`;

export const MenuItem = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  color: ${palette.colors.onsurface};

  &:hover {
    background-color: rgba(26, 28, 25, 0.08);
  }
`;

export const MenuText = styled.div`
  ${typography.body_large_regular};
`;

export const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    border-radius: ${shape.rounding.XXL};
    background-color: ${palette.colors.surface_container_high};
    padding: 24px;
    width: 375px;
  }
  & .MuiDialog-paper h2 {
    ${typography.headline_small};
    padding: 0;
    margin-bottom: 16px;
  }
  & .MuiDialogContent-root {
    padding: 0;
  }

  & .MuiDialogActions-root {
    padding-top: 24px;
    padding-bottom: 0;
  }
`;

export const StyledDialogContentText = styled(DialogContentText)`
  color: ${palette.colors.onsurface_variant};
  ${typography.body_medium_regular};
`;
